import { render, staticRenderFns } from "./users.vue?vue&type=template&id=918b54d4&"
import script from "./users.js?vue&type=script&lang=js&"
export * from "./users.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports